import { defaultErrorHandler } from '@shared/utils/default-error-handler';

import { reactive, computed } from '@vue/composition-api';
import { get } from '@shared/transforming-keys-axios';

import { materialsPath } from '@app/edu_materials/paths.js.erb';

import { cancelledRequestHandler, useCancelToken } from '@shared/vuex/utils';

import { state as globalState } from '@app/edu_materials/stores/global-store';
import handleSEO from '../util/handle-seo';

const state = reactive({
  loading: false,
  initialized: false,

  materials: [],

  selectedAuthorSlug: null,
  selectedAuthor: computed(() => {
    return globalState.authors.find(({ slug }) => slug === state.selectedAuthorSlug);
  }),

  selectedCategorySlug: null,
  selectedCategory: computed(() => globalState.categories.find(({ slug }) => slug === state.selectedCategorySlug)),

  search: '',

  currentPage: 1,
  totalPages: 1,
});

/* global App */
App.materials = state;

function fetchData () {
  state.loading = true;

  get(`${materialsPath}/${ state.selectedCategorySlug || '' }`, {
    params: {
      authorSlug: state.selectedAuthorSlug,
      search: state.search,
      page: state.currentPage,
    },

    cancelToken: useCancelToken(materialsPath),
  })
    .then(handleSEO)
    .then(({ data: { materials, meta: { currentPage, totalPages } } }) => {
      state.materials = materials;

      state.currentPage = currentPage;
      state.totalPages = totalPages;

      state.initialized = true;
      state.loading = false;
    })
    .catch(cancelledRequestHandler)
    .catch(defaultErrorHandler);
}

export {
  state,
  fetchData,
};
